import { InjectionToken } from '@angular/core';
import { LanguageResourceType } from '../types/language-resource-config.type';

export const LOCALIZATION_RESOURCE = new InjectionToken<LanguageResourceType>('LOCALIZATION_RESOURCE');
